import { render, staticRenderFns } from "./Bando25Fase4.vue?vue&type=template&id=68de9e0c&scoped=true"
import script from "./Bando25Fase4.vue?vue&type=script&lang=js"
export * from "./Bando25Fase4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de9e0c",
  null
  
)

export default component.exports